import React from 'react'

export default function StatusContainer({ text, bg = "bg-green-500", textcolor = "text-white" }) {
    return (
        <span class="ml-auto"><span
            class={" py-1 px-2 rounded text-xs " + bg + " " + textcolor}>{text}</span>
        </span>
    )
}
